import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * TA-10279: Project/Task tag row placeholder — mirrors `ProjectTag.tsx` /
 * `TaskTag.tsx`'s row (small icon + single text line), with an optional
 * trailing 2-avatar stack for the task variant. Used by the Chat Related
 * Tags modal and the Assign-to-Task project/task search.
 */
export const TagRowSkeleton: React.FC<{
  testID?: string;
  showAvatars?: boolean;
}> = ({ testID = 'tag-row-skeleton', showAvatars = false }) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      paddingVertical='s'
      paddingHorizontal='xs'>
      <Skeleton variant='rect' width={16} height={16} borderRadius='xxs' />
      <Box flex={1} marginLeft='xs'>
        <Skeleton variant='text' width='50%' />
      </Box>
      {showAvatars && (
        <Box flexDirection='row'>
          <Skeleton variant='circle' width={20} height={20} />
          <Skeleton
            variant='circle'
            width={20}
            height={20}
            style={{ marginLeft: -theme.spacing.xxs }}
          />
        </Box>
      )}
    </Box>
  );
};
